module.exports = __webpack_public_path__ + "static/media/back-arrow.6b0077ef.svg";